import React from "react";
import LegalPageLayout from "../components/LegalPageLayout";
export default function TermsConditions() {
  return <LegalPageLayout tKey="terms" />;
}
